module.exports = __webpack_public_path__ + "static/media/home-retro-occupy.d3d02c97.jpg";